// extracted by mini-css-extract-plugin
export default {"title":"whatIfStory_title__vL5Uw"};